import { render, staticRenderFns } from "./QuoteVehicle.vue?vue&type=template&id=fc012cdc&scoped=true"
import script from "./QuoteVehicle.vue?vue&type=script&lang=js"
export * from "./QuoteVehicle.vue?vue&type=script&lang=js"
import style0 from "./QuoteVehicle.vue?vue&type=style&index=0&id=fc012cdc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc012cdc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fc012cdc')) {
      api.createRecord('fc012cdc', component.options)
    } else {
      api.reload('fc012cdc', component.options)
    }
    module.hot.accept("./QuoteVehicle.vue?vue&type=template&id=fc012cdc&scoped=true", function () {
      api.rerender('fc012cdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/components/QuoteHeader/QuoteVehicle.vue"
export default component.exports